'use es6';

import PropTypes from 'prop-types';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledRating = styled.div.withConfig({
  displayName: "FeedbackNpsMobileRating__StyledRating",
  componentId: "lwjira-0"
})(({
  theme,
  isSelected
}) => `
  cursor: pointer;
  color: ${theme.color['text-core-default']};
  border-radius: ${theme.borderRadius['100']};
  background-color: ${isSelected ? theme.color['fill-tertiary-pressed'] : theme.color['fill-tertiary-default']};
  border: ${theme.borderWidth['200']} solid ${theme.color['border-tertiary-default']};
  font-size: ${theme.typography['detail-100'].fontSize};
  margin: ${theme.space['0']} auto ${theme.space['300']};
  padding: ${theme.space['500']} ${theme.space['250']};
  text-align: center;
  width: 60%;

  &:hover {
    background-color: ${theme.color['fill-tertiary-hover']};
  }
`);
const FeedbackNpsMobileRating = ({
  children,
  onRatingChange = () => {},
  selectedRating,
  value
}) => /*#__PURE__*/_jsx(StyledRating, {
  "data-test-id": `nps-mobile-rating-${value}`,
  onClick: () => onRatingChange(value),
  isSelected: selectedRating === value,
  children: children
});
FeedbackNpsMobileRating.propTypes = {
  children: PropTypes.node.isRequired,
  onRatingChange: PropTypes.func,
  selectedRating: PropTypes.number,
  value: PropTypes.number.isRequired
};
export default FeedbackNpsMobileRating;